import { number, object } from "yup";

export interface CurrentSubscriptionFeatureResource {
  feature: {
    id: number;
  };
  value: number;
}

export const currentSubscriptionFeatureResourceSchema = object({
  feature: object({
    id: number().required(),
  }).required(),
  value: number().required(),
});
